import { AppStorage } from "@bbwt/utils/app-storage";
import { PatientLogin } from "@main/users";
import { EpisodeOfflineStorage } from "@project/episode/episode-offline.storage";
import { IEpisode } from "@project/models/episodes/episode";

export class PlayerOfflineStorage {
    private static readonly cacheKey = "api/end-user";

    static get(id: string) {
        return AppStorage.getOfflineEntity<PatientLogin>(id, this.cacheKey);
    }

    static save(player: PatientLogin) {
        return AppStorage.setOfflineEntity<PatientLogin>(this.cacheKey, player);
    }

    static remove(id: string) {
        return AppStorage.extractOfflineEntity<PatientLogin>(id, this.cacheKey);
    }

    static getAll(): PatientLogin[] {
        return AppStorage.getOfflineEntities<PatientLogin>(this.cacheKey);
    }

    static update(player: PatientLogin) {
        return AppStorage.replaceOfflineEntity(player, this.cacheKey);
    }

    static getEpisodes(patientId: string): IEpisode[] {
        return EpisodeOfflineStorage.getAll().filter(e => e.patientUserId === patientId);
    }
}
